+function ($) {
    $(document).ready(function(){
        $('.vacancy__block__links a').click(function() {
            const id = $(this).parent().find('.vacancy__id').html();
            $('#modal-form-vacancy input[name="vacancy"]').val(id);
        });
    });
}(jQuery);
